var map = {
	"./about/About.vue": [
		"ef4c",
		"chunk-b6a32b00"
	],
	"./componets/Breadcrumb.vue": [
		"ed87",
		"chunk-138356cf"
	],
	"./componets/Footer.vue": [
		"dafb",
		"chunk-3164a1f0"
	],
	"./componets/Header.vue": [
		"8967",
		"chunk-6e9ec8ea"
	],
	"./componets/NewBreadcrumb.vue": [
		"e45a",
		"chunk-71e43d50"
	],
	"./componets/ScienceBreadcrumb.vue": [
		"ace6",
		"chunk-6ccfde89"
	],
	"./contact/Contact-备份.vue": [
		"4886",
		"chunk-6d018f1a",
		"chunk-e7a5dd3c"
	],
	"./contact/Contact.vue": [
		"410a",
		"chunk-6ffb7b8c",
		"chunk-6d018f1a",
		"chunk-8cd5436a"
	],
	"./decennial/Decennial.vue": [
		"b656",
		"chunk-11466879",
		"chunk-7d52eda7"
	],
	"./home/Home.vue": [
		"b3d7",
		"chunk-6ffb7b8c",
		"chunk-f6cf3d3c"
	],
	"./home/componets/News.vue": [
		"e462",
		"chunk-6ffb7b8c",
		"chunk-2956a310"
	],
	"./home/componets/Solution.vue": [
		"362b",
		"chunk-f479618c"
	],
	"./medium/Medium.vue": [
		"c978",
		"chunk-6ffb7b8c",
		"chunk-a64fe5e4"
	],
	"./medium/MediumDetail.vue": [
		"5563",
		"chunk-6ffb7b8c",
		"chunk-ca50db92"
	],
	"./medium/SubView.vue": [
		"b6ce",
		"chunk-142893c9"
	],
	"./products/Product.vue": [
		"2ade",
		"chunk-68aef240",
		"chunk-4f44a0da"
	],
	"./products/SubView.vue": [
		"de49",
		"chunk-4e66cc7f"
	],
	"./products/componets/RelatedProduct.vue": [
		"9ad6",
		"chunk-11466879",
		"chunk-e9e4554e"
	],
	"./products/details/Autoflak.vue": [
		"8709",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-74eb6932"
	],
	"./products/details/Autopipeline.vue": [
		"f981",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-60c93448"
	],
	"./products/details/BloodPushing.vue": [
		"d442",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-578a527e"
	],
	"./products/details/DnaProd.vue": [
		"51c6",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-47bb09f2",
		"chunk-bc1852cc"
	],
	"./products/details/DnaReagent.vue": [
		"7a63",
		"chunk-11466879",
		"chunk-4aeb1346"
	],
	"./products/details/Film.vue": [
		"046e",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-47bb09f2",
		"chunk-5e4ba2dc"
	],
	"./products/details/Gemini.vue": [
		"4f55",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-335c5498"
	],
	"./products/details/Marrow.vue": [
		"43ac",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-55b2f7cb"
	],
	"./products/details/Patholog.vue": [
		"def2",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-6eb8777f"
	],
	"./products/details/Pelleter.vue": [
		"d46a",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-30c76217"
	],
	"./products/details/Special.vue": [
		"a686",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-47bb09f2",
		"chunk-5b7ee646"
	],
	"./products/details/TctProd.vue": [
		"6e2e",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-23ae154c",
		"chunk-2367180d"
	],
	"./products/details/TctReagent.vue": [
		"cdff",
		"chunk-11466879",
		"chunk-7c638545"
	],
	"./science/DecipherDetail.vue": [
		"4ea3",
		"chunk-6ffb7b8c",
		"chunk-0eefa2d6"
	],
	"./science/DoctorDetail.vue": [
		"0ff7",
		"chunk-6ffb7b8c",
		"chunk-2d21d0c2",
		"chunk-286cf843"
	],
	"./science/Science.vue": [
		"4213",
		"chunk-6ffb7b8c",
		"chunk-6d018f1a",
		"chunk-2c64c07c"
	],
	"./science/SubView.vue": [
		"7c1d",
		"chunk-e4a8339e"
	],
	"./science/componets/Decipher.vue": [
		"6030",
		"chunk-6ffb7b8c",
		"chunk-7a3a7178"
	],
	"./science/componets/Doctor.vue": [
		"4736",
		"chunk-6ffb7b8c",
		"chunk-317604aa"
	],
	"./solution/Solution.vue": [
		"281e",
		"chunk-68aef240",
		"chunk-112f4ea6"
	],
	"./solution/SubView.vue": [
		"3f42",
		"chunk-0f33a633"
	],
	"./solution/componets/RelatedProduct.vue": [
		"69bf",
		"chunk-11466879",
		"chunk-6325a59c"
	],
	"./solution/details/Blood.vue": [
		"c1ec",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-a7bbbd54"
	],
	"./solution/details/Dna.vue": [
		"2bdd",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-7dcbbf5e"
	],
	"./solution/details/Tbs.vue": [
		"92fae",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-58c1277a"
	],
	"./solution/details/Telepathology.vue": [
		"3351",
		"chunk-6ffb7b8c",
		"chunk-11466879",
		"chunk-46159462"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;